import { api } from '@/context/AuthContext';

export async function buscarPerfil() {
  const { data } = await api.get('/usuario/perfil');
  return data;
}

export async function salvarPerfil(campos) {
  const { data } = await api.patch('/usuario/perfil', campos);
  return data;
}

export async function alterarSenha(senhaAtual, novaSenha) {
  const { data } = await api.post('/usuario/alterar-senha', {
    senhaAtual,
    novaSenha,
  });
  return data;
}

export async function buscarMeusEventos() {
  const { data } = await api.get('/usuario/eventos');
  return data;
}

export async function buscarMinhaAssinatura() {
  const { data } = await api.get('/usuario/assinatura');
  return data;
}

export async function buscarMeusPedidos() {
  const { data } = await api.get('/usuario/pedidos');
  return data;
}
